import { render, staticRenderFns } from "./ModalAddPages.vue?vue&type=template&id=5c096708"
import script from "./ModalAddPages.vue?vue&type=script&lang=js"
export * from "./ModalAddPages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports